module.exports = __webpack_public_path__ + "static/img/visas.d6e9e9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/wallets/visas.jpg
// module id = 27
// module chunks = 1